<mat-card class="ticket-card" (click)="navigateToTicket()">
    <mat-card-content>
        <div class="ticket-header">
            <span class="ticket-id">#{{ticket.id}}</span>
            <span class="ticket-title">{{ticket.title}}</span>
        </div>
        <p class="ticket-body">{{ticket.body}}</p>
        <div class="ticket-footer">
            <div class="requester">
                <mat-icon>person</mat-icon>
                <span>{{ticket.requester.name}}</span>
            </div>
            <div class="status">
                <span class="ticket-status" [ngClass]="ticket.status.toLowerCase()">
                    {{getStatusTranslation(ticket.status)}}
                </span>
            </div>
            <div class="date">
                <span class="ticket-date">{{ticket.createDate | date:'dd/MM/yyyy'}}</span>
            </div>
        </div>
    </mat-card-content>
</mat-card>
